export default {"src":"/_next/static/media/gr.9a15db27.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};